import { useState } from 'react';
import PartnerInquiryModal from './PartnerInquiryModal';

export default function Hero() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showSuccessBanner, setShowSuccessBanner] = useState(false);

  const handleSuccess = () => {
    setShowSuccessBanner(true);
  };

  return (
    <>
      {showSuccessBanner && (
        <div className="fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-green-600 to-green-700 text-white py-3 px-3 shadow-2xl animate-slide-down">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-full flex-shrink-0">
                <i className="ri-check-line text-xl"></i>
              </div>
              <div className="flex-1 min-w-0 pr-2">
                <h3 className="text-base font-bold mb-1">Thanks for getting in touch!</h3>
                <p className="text-sm text-white/95 leading-relaxed">
                  We're excited to connect and see how we can work together. We've received your message and will follow up with you shortly. Feel free to call us directly at <a href="tel:+14132227701" className="font-semibold underline hover:text-yellow-300 transition-colors cursor-pointer whitespace-nowrap">(413) 222-7701</a>.
                </p>
                <p className="text-xs text-white/80 mt-2">
                  — Chris Leary, Founder and Tour Director, Bucket List Golf
                </p>
              </div>
              <button
                onClick={() => setShowSuccessBanner(false)}
                className="text-white hover:text-white/80 transition-colors cursor-pointer flex-shrink-0 w-8 h-8 flex items-center justify-center -mr-1"
                aria-label="Close banner"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="hero-section relative min-h-screen flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0"
        >
          <img
            src="https://static.readdy.ai/image/57c982531ce74d8992a8785896e0bafd/12004c051679f4f439ca904bdb7dd66a.jpeg"
            alt="Luxury Golf Course"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
        </div>
        
        <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 text-center w-full">
          <p className="text-yellow-400 text-xs sm:text-sm md:text-base font-medium tracking-[0.2em] sm:tracking-[0.3em] uppercase mb-3 sm:mb-4">
            Bucket List Golf
          </p>
          <h1 className="text-4xl sm:text-5xl md:text-7xl font-black text-white mb-6 sm:mb-8 leading-none tracking-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            PARTNERSHIP
          </h1>
          <div className="flex justify-center mb-6 sm:mb-8">
            <img
              src="https://static.readdy.ai/image/57c982531ce74d8992a8785896e0bafd/10d9fc1b609b54364963a5ea239520dd.png"
              alt="Bucket List Golf"
              className="h-24 sm:h-32 md:h-40 w-auto"
            />
          </div>
          <p className="text-sm sm:text-base md:text-lg text-white/90 max-w-3xl mx-auto leading-relaxed mb-8 sm:mb-12 px-2">
            Partner with us to create unforgettable experiences for golf's most passionate community—and connect your brand with the people who live for the game.
          </p>
          <div className="mt-8 sm:mt-10">
            <button
              onClick={() => setIsModalOpen(true)}
              className="group relative px-8 sm:px-12 py-3 sm:py-4 bg-gradient-to-r from-yellow-400 to-yellow-500 text-gray-900 text-sm sm:text-base font-bold rounded-full hover:from-yellow-500 hover:to-yellow-600 transition-all duration-300 shadow-2xl hover:shadow-yellow-500/50 hover:scale-105 whitespace-nowrap cursor-pointer tracking-wide uppercase border-2 border-yellow-300"
            >
              <span className="relative z-10">Get In Touch</span>
              <div className="absolute inset-0 rounded-full bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </button>
          </div>
        </div>
      </div>

      <PartnerInquiryModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)}
        onSuccess={handleSuccess}
      />
    </>
  );
}
